import {
  refreshTokens
} from "./chunk-5DBT6SVI.mjs";

// src/hooks/wbk/auth/refreshTokens.ts
import { useMutation } from "@tanstack/react-query";
var useRefreshTokens = () => {
  return useMutation({
    mutationFn: refreshTokens
  });
};

export {
  useRefreshTokens
};
//# sourceMappingURL=chunk-OBUJDSDQ.mjs.map